import Router from "next/router";

import { getConfig } from "src/common/config";
import { navigateHome } from "src/common/authorisation/session";
import { CountryCodeSupported } from "src/common/country";
import { FullStory } from "src/technical-integrations/fullstory";
import { UnauthenticatedOptimizely } from "src/technical-integrations/optimizely";
import { useAccessToken } from "src/common/authorisation";

const NoAuthSync: React.FC<{
  children: React.ReactNode;
  ignoreAccessToken?: boolean;
  userCountry: CountryCodeSupported;
}> = ({ children, ignoreAccessToken, userCountry }) => {
  const [accessToken] = useAccessToken();

  if (accessToken && !ignoreAccessToken) {
    if (getConfig().shared.enableDevelopmentRoute) {
      Router.push({ pathname: "/" });
    } else {
      navigateHome({});
    }
    return null;
  }

  return (
    <UnauthenticatedOptimizely userCountry={userCountry}>
      <FullStory />
      {children}
    </UnauthenticatedOptimizely>
  );
};

export default NoAuthSync;
